"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavMobile = void 0;

var react_1 = __importDefault(require("react"));

var NavMobile = function NavMobile(_a) {
  var menuVisible = _a.menuVisible,
      menuToggle = _a.menuToggle;
  console.log(menuVisible);
  console.log(menuToggle);
  return react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement("div", {
    className: "md:hidden"
  }, react_1["default"].createElement("div", {
    className: "fixed inset-0 flex z-40"
  }, react_1["default"].createElement("div", {
    className: "fixed inset-0"
  }, react_1["default"].createElement("div", {
    className: "absolute inset-0 bg-gray-600 opacity-75"
  })), react_1["default"].createElement("div", {
    className: "relative flex-1 flex flex-col max-w-xs w-full bg-white"
  }, react_1["default"].createElement("div", {
    className: "absolute top-0 right-0 -mr-14 p-1"
  }, react_1["default"].createElement("button", {
    className: "flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600",
    "aria-label": "Close sidebar"
  }, react_1["default"].createElement("svg", {
    className: "h-6 w-6 text-white",
    stroke: "currentColor",
    fill: "none",
    viewBox: "0 0 24 24"
  }, react_1["default"].createElement("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })))), react_1["default"].createElement("div", {
    className: "flex-1 h-0 pt-5 pb-4 overflow-y-auto"
  }, react_1["default"].createElement("div", {
    className: "flex-shrink-0 flex items-center px-4"
  }, react_1["default"].createElement("img", {
    className: "h-8 w-auto",
    src: "/img/logos/workflow-logo-on-white.svg",
    alt: "Workflow"
  })), react_1["default"].createElement("nav", {
    className: "mt-5 px-2"
  }, react_1["default"].createElement("a", {
    href: "#",
    className: "group flex items-center px-2 py-2 text-base leading-6 font-medium text-gray-900 rounded-md bg-gray-100 focus:outline-none focus:bg-gray-200 transition ease-in-out duration-150"
  }, react_1["default"].createElement("svg", {
    className: "mr-4 h-6 w-6 text-gray-500 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, react_1["default"].createElement("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
  })), "Dashboard"), react_1["default"].createElement("a", {
    href: "#",
    className: "mt-1 group flex items-center px-2 py-2 text-base leading-6 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:text-gray-900 focus:bg-gray-100 transition ease-in-out duration-150"
  }, react_1["default"].createElement("svg", {
    className: "mr-4 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, react_1["default"].createElement("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
  })), "Team"), react_1["default"].createElement("a", {
    href: "#",
    className: "mt-1 group flex items-center px-2 py-2 text-base leading-6 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:text-gray-900 focus:bg-gray-100 transition ease-in-out duration-150"
  }, react_1["default"].createElement("svg", {
    className: "mr-4 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, react_1["default"].createElement("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
  })), "Projects"), react_1["default"].createElement("a", {
    href: "#",
    className: "mt-1 group flex items-center px-2 py-2 text-base leading-6 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:text-gray-900 focus:bg-gray-100 transition ease-in-out duration-150"
  }, react_1["default"].createElement("svg", {
    className: "mr-4 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, react_1["default"].createElement("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
  })), "Calendar"), react_1["default"].createElement("a", {
    href: "#",
    className: "mt-1 group flex items-center px-2 py-2 text-base leading-6 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:text-gray-900 focus:bg-gray-100 transition ease-in-out duration-150"
  }, react_1["default"].createElement("svg", {
    className: "mr-4 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, react_1["default"].createElement("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
  })), "Documents"), react_1["default"].createElement("a", {
    href: "#",
    className: "mt-1 group flex items-center px-2 py-2 text-base leading-6 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:text-gray-900 focus:bg-gray-100 transition ease-in-out duration-150"
  }, react_1["default"].createElement("svg", {
    className: "mr-4 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, react_1["default"].createElement("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
  })), "Reports"))), react_1["default"].createElement("div", {
    className: "flex-shrink-0 flex border-t border-gray-200 p-4"
  }, react_1["default"].createElement("a", {
    href: "#",
    className: "flex-shrink-0 group block focus:outline-none"
  }, react_1["default"].createElement("div", {
    className: "flex items-center"
  }, react_1["default"].createElement("div", null, react_1["default"].createElement("img", {
    className: "inline-block h-10 w-10 rounded-full",
    src: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    alt: ""
  })), react_1["default"].createElement("div", {
    className: "ml-3"
  }, react_1["default"].createElement("p", {
    className: "text-base leading-6 font-medium text-gray-700 group-hover:text-gray-900"
  }, "Tom Cook"), react_1["default"].createElement("p", {
    className: "text-sm leading-5 font-medium text-gray-500 group-hover:text-gray-700 group-focus:underline transition ease-in-out duration-150"
  }, "View profile")))))), react_1["default"].createElement("div", {
    className: "flex-shrink-0 w-14"
  }))));
};

exports.NavMobile = NavMobile;